define('tracks/track-enabled',["require", "exports", "../util/observable", "../util/pubsub", "./track-store", "./virtual-track"], function (require, exports, observable_1, pubsub_1, trackStore, virtual_track_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.removeAll = exports.remove = exports.observe = exports.isEnabled = exports.addWse = exports.addLaser = exports.addTrack = exports.trackDisabled = exports.trackEnabled = exports.pending = exports.enabled = void 0;
    exports.enabled = {};
    exports.pending = {};
    var enabledState = {};
    /**
     * Subscribe to track enabled / disabled events
     */
    exports.trackEnabled = new pubsub_1.PubSub();
    exports.trackDisabled = new pubsub_1.PubSub();
    function addTrack(trackId) {
        if (!isEnabled(trackId)) {
            observe(trackId).set(true);
            exports.pending[trackId] = trackStore.getTrackData(trackId);
            exports.pending[trackId].then(function (track) {
                exports.enabled[trackId] = track;
                exports.trackEnabled.post(track);
            });
        }
        else {
            console.error("Track added twice", trackId);
        }
    }
    exports.addTrack = addTrack;
    function addLaser(laser) {
        var track = (0, virtual_track_1.laserTrack)(laser);
        observe(track.track_id).set(true);
        exports.enabled[track.track_id] = track;
        exports.pending[track.track_id] = Promise.resolve(track);
        exports.trackEnabled.post(track);
    }
    exports.addLaser = addLaser;
    function addWse(wspoints) {
        var track = (0, virtual_track_1.wseTrack)(wspoints);
        observe(track.track_id).set(true);
        exports.enabled[track.track_id] = track;
        exports.pending[track.track_id] = Promise.resolve(track);
        exports.trackEnabled.post(track);
    }
    exports.addWse = addWse;
    /**
     * Is track enabled?
     */
    function isEnabled(trackId) {
        if (enabledState[trackId] === undefined) {
            enabledState[trackId] = new observable_1.Observable(false);
        }
        return enabledState[trackId].get();
    }
    exports.isEnabled = isEnabled;
    function observe(trackId) {
        if (enabledState[trackId] === undefined) {
            enabledState[trackId] = new observable_1.Observable(false);
        }
        return enabledState[trackId];
    }
    exports.observe = observe;
    function remove(trackId) {
        enabledState[trackId].set(false);
        delete exports.enabled[trackId];
        delete exports.pending[trackId];
        exports.trackDisabled.post(trackId);
    }
    exports.remove = remove;
    function removeAll() {
        for (var trackId in enabledState) {
            if (enabledState[trackId].get()) {
                remove(trackId);
            }
        }
    }
    exports.removeAll = removeAll;
});
//# sourceMappingURL=/assets/javascripts/tracks/track-enabled.js.map;
